import React, { useEffect, useState } from "react";
import InnerLayout from "../../../components/layouts/inner-layout";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import LoadingSpinner from "../../../components/helper-components/loading-spinner";
import CreateEditViewPurchasePaymentOut from "../../../components/purchase-section/purchase-payment-out/create-edit-view-payment-out";
import { paymentOutViewAction } from "../../../redux/actions/purchase-action";

const ViewPaymentOut = () => {
  const { id } = useParams();
  const [orderDetail, setOrderDetail] = useState({});
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(paymentOutViewAction(id, onSuccPur, onErrPur));
  }, []);

  const onSuccPur = (data) => {
    setOrderDetail(data?.data);
    setLoading(false);
  };

  const onErrPur = (data) => {
    setLoading(false);
  };

  return (
    <InnerLayout backBtn={true} title="View Payment Out">
      {loading ? (
        <LoadingSpinner />
      ) : (
        <CreateEditViewPurchasePaymentOut
          disabled={true}
          data={orderDetail}
          page="view"
        />
      )}
    </InnerLayout>
  );
};

export default ViewPaymentOut;
